import {useQuery, type QueryKey} from '@github-ui/react-query'
import type {FilesRoutePayload} from '../payloads/files'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'

export function pullRequestTableOfContentsKey(basePath: string): QueryKey {
  return [PageData.tableOfContents, basePath]
}

function pullRequestTableOfContentsPayload(basePath: string) {
  const queryKey = pullRequestTableOfContentsKey(basePath)
  return {
    queryKey,
    queryFn: async () => {
      // we're not fetching from an API yet, seeding TSQ with payload data for re-use
      return undefined
    },
  }
}

export type TableOfContents = FilesRoutePayload['diffSummaries']

export function useTableOfContentsData({
  basePath,
  initialData,
  filePath,
}: {
  basePath: string
  initialData?: TableOfContents
  filePath: string
}) {
  const {queryFn, queryKey} = pullRequestTableOfContentsPayload(basePath)
  return useQuery({
    queryKey,
    queryFn,
    initialData,
    select: data => {
      if (!data) return undefined
      return data.find(summary => summary.path === filePath)
    },
    staleTime: Infinity,
  })
}
